module.exports = __webpack_public_path__ + "img/help_compare2.c8100c29.png";